const createUserModalOpened = ref(false)

export const useUsers = () => {
  return {
    createUserModalOpened,
  }
}
